// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  PROP_FIELD,
} from 'hfty-model-comments'

import {
  ADD_COMMENT,
  DELETE_COMMENTS,
} from './constants'

export function addComment ({ field }: {field: number}): Action<> {
  return {
    type: ADD_COMMENT,
    payload: {
      [PROP_FIELD]: field,
    },
  }
}

export function deleteComments (): Action<> {
  return {
    type: DELETE_COMMENTS,
  }
}
